import React,{useState} from "react";


export const ThemeContext = React.createContext();

const ThemeProvider = (props) => {

  const initialState = {
    sidebarShow: true,
    unfoldable:true
  };

  const [theme, setTheme] = useState(initialState);



  const cambioTheme = (valor) => {
    setTheme(valor);
    //sessionStorage.setItem("themeLocal", JSON.stringify(valor));
  };

  

  return (
    <ThemeContext.Provider value={{ theme, cambioTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
